import loadInitializers from 'ember-load-initializers';
import { registerDateLibrary } from 'ember-power-calendar';
import PowerCalendarLibrary from 'volta/utils/power-calendar/library';
import Application from '@ember/application';
import EmberObject from '@ember/object';
import config from './config/environment';
import { initSentry } from './sentry';
import Resolver from 'ember-resolver';
import { clearLocalStorage } from './version';
import '@warp-drive/ember/install';

initSentry();
registerDateLibrary(PowerCalendarLibrary);
clearLocalStorage();

class App extends Application {
  Resolver = Resolver;
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
}

loadInitializers(App, config.modulePrefix);

EmberObject.reopen({
  toNative() {
    return Object.assign({}, this);
  },
  toJSON(this: { toNative: () => object }) {
    return JSON.stringify(this.toNative());
  }
});

export default App;
